// extracted by mini-css-extract-plugin
export default {"ellipsis":"WMQVMF0FZ_hgR7gcja8c","wrapper":"bdNX_OmfNs_pl38Nfa1R","clappingHandsAnimation":"t4scD3Rn0IMwn8yEuXRb","spin":"q5Lu7rfEMthSh1Vw8lFF"};